<template>
  <searchable-object-selector
      ref="selector"
      :objects="sorted"
      :disabled="disabled"
      :placeholder="placeholder"
      :formatter="formatter"
      @input="input"
      :value="value"
      :state="state" />
</template>

<script>
export default {
  name: 'storage-location-selector',
  props: {
    value: Object,
    allowNull: {
      Boolean,
      default () {
        return false
      }
    },
    disabled: {
      Boolean,
      default () {
        return false
      }
    },
    size: String,
    placeholder: String,
    state: {
      Boolean,
      default () {
        return null
      }
    }
  },
  data: () => ({ objs: [] }),
  computed: {
    sorted () {
      return this.objs.slice().sort((a, b) => a.site.name.localeCompare(b.site.name))
    }
  },
  methods: {
    input (v) {
      this.$emit('input', v)
    },
    selectById (id) {
      this.$refs.selector.selectById(id)
    },
    formatter: (o) => `${o.site.name}: ${o.name}`
  },
  async mounted () {
    this.objs = await ArcAPI.meta.company.storage_locations.list()
  }
}
</script>
